import Folder from '../store/schema/Folder';
import getMailboxRootFolder from './getMailboxRootFolder';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID } from '../util/folderConstants';

/**
 * Archive mailbox root folder selector
 */
export default function getArchiveMailboxRootFolder(): Folder {
    return getMailboxRootFolder(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID);
}
